<template>
	<div ref="container"></div>
</template>

<script>
import WordCloudWidget from '@/widgets/WordCloudWidget';

const SAMPLE_WORDS = [
	'stream', 'hello', 'PogChamp', 'hype', 'love', 'chat', 'follow', 'subscribe',
	'Kappa', 'awesome', 'thanks', 'gg', 'lol', 'clip', 'raid', 'game', 'pog', 'wow',
	'monka', 'win', 'haha', 'nice', 'based', 'copium', 'sadge', 'pepe', 'clap',
	'lurk', 'vibe', 'hype', 'goat', 'based', 'noice', 'ez', 'rip', 'bruh', 'lets',
	'go', 'poggers', 'pepehands', 'dansgame', 'jebaited', 'kreygasm', 'trihard',
	'4head', 'biblethump', 'notlikethis', 'residentsleeper', 'omegalul', 'lulw',
	'monkas', 'widepeeposad', 'feelsweakman', 'catjam', 'sumsmash', 'donowall',
	'prime', 'bits', 'cheer', 'goal', 'alert', 'timer', 'emote', 'badge', 'rank',
	'first', 'banger', 'clip', 'pogU', 'ready', 'hug', 'yes', 'no', 'maybe', 'soon',
	'100', 'W', 'L', 'real', 'fake', 'true', 'false', 'good', 'bad', 'best', 'worst',
	'play', 'pause', 'stop', 'start', 'restart', 'reset', 'lag', 'fps', 'smooth',
	'fire', 'ice', 'wild', 'crazy', 'insane', 'skill', 'clutch', 'carry', 'feed',
	'bot', 'flex', 'meta', 'patch', 'nerf', 'buff', 'ranked', 'casual', 'tournament',
].map((word, i, arr) => ({ word, n: arr.length - i }));

const mockSocket = { subscribe() { return 0; }, unsubscribe() {} };


export default {
	name: 'WordCloudWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			const self = this;
			const api = {
				get(path) {
					if(path.includes('/settings/')) return Promise.resolve({ ...self.settings });
					if(path.endsWith('/words')) return Promise.resolve(SAMPLE_WORDS);
					return Promise.resolve({});
				},
			};

			this.widget = new WordCloudWidget({
				container: this.$refs.container,
				api,
				socket: mockSocket,
				hash: 'preview',
			});

			// Strip html/body rules injected by the widget — they break the settings page layout.
			const baseCSSElem = document.getElementById('wordCloudBaseCSS');
			if(baseCSSElem) {
				baseCSSElem.textContent = baseCSSElem.textContent
					.replace(/(?:html|body)(?:\s*,\s*(?:html|body))?\s*\{[^}]*\}/g, '');
			}

			await this.widget.init();
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
	},
};
</script>
